/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-webapp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.51
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DbChange } from './DbChange';
import {
    DbChangeFromJSON,
    DbChangeFromJSONTyped,
    DbChangeToJSON,
} from './DbChange';

/**
 * 
 * @export
 * @interface DbChangeSet
 */
export interface DbChangeSet {
    /**
     * 
     * @type {string}
     * @memberof DbChangeSet
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof DbChangeSet
     */
    dateTime?: Date;
    /**
     * 
     * @type {Array<DbChange>}
     * @memberof DbChangeSet
     */
    changes?: Array<DbChange>;
}

/**
 * Check if a given object implements the DbChangeSet interface.
 */
export function instanceOfDbChangeSet(value: object): value is DbChangeSet {
    return true;
}

export function DbChangeSetFromJSON(json: any): DbChangeSet {
    return DbChangeSetFromJSONTyped(json, false);
}

export function DbChangeSetFromJSONTyped(json: any, ignoreDiscriminator: boolean): DbChangeSet {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'dateTime': json['dateTime'] == null ? undefined : (new Date(json['dateTime'])),
        'changes': json['changes'] == null ? undefined : ((json['changes'] as Array<any>).map(DbChangeFromJSON)),
    };
}

export function DbChangeSetToJSON(value?: DbChangeSet | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'dateTime': value['dateTime'] == null ? undefined : ((value['dateTime']).toISOString()),
        'changes': value['changes'] == null ? undefined : ((value['changes'] as Array<any>).map(DbChangeToJSON)),
    };
}

